import { Component, computed, inject, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { PopoverModule } from 'primeng/popover';
import { Router } from '@angular/router';
import { PlatformService } from '@core/services/platform/platform.service';
import { AnalyticsService } from '@core/services/analytics/analytics.service';

@Component({
  selector: 'mohlel-info-tooltip',
  imports: [NgTemplateOutlet, TooltipModule, PopoverModule],
  template: `
    @if (isMobile()) {
      <i class="pi pi-info-circle" (click)="popover.toggle($event)" aria-hidden="true"></i>
      <p-popover #popover styleClass="info-tooltip-popover" (onShow)="trackViewed()">
        @if (isTemplate()) {
          <ng-container [ngTemplateOutlet]="$any(content())"></ng-container>
        } @else {
          <div class="tooltip-content">{{ content() }}</div>
        }
      </p-popover>
    } @else {
      <i
        class="pi pi-info-circle"
        aria-hidden="true"
        (mouseenter)="trackViewed()"
        [pTooltip]="isTemplate() ? $any(content()) : $any(content())"
        [tooltipOptions]="{
          tooltipPosition: tooltipPosition(),
          tooltipStyleClass: tooltipStyleClass(),
        }"
      ></i>
    }
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }

      .pi-info-circle {
        cursor: pointer;
      }
    `,
  ],
})
export class InfoTooltipComponent {
  content = input.required<string | TemplateRef<unknown>>();
  tooltipStyleClass = input<string>('info-tooltip');
  tooltipPosition = input<'top' | 'right' | 'left' | 'bottom'>('top');
  metricName = input<string>();

  private platformService = inject(PlatformService);
  private router = inject(Router);
  private analyticsService = inject(AnalyticsService);

  isMobile = computed(
    () =>
      this.platformService.isMobile() ||
      !window.matchMedia('(hover: hover) and (pointer: fine)').matches
  );
  isTemplate = computed(() => this.content() instanceof TemplateRef);

  trackViewed(): void {
    this.analyticsService.trackInfoTooltipViewed({
      metricName: this.metricName(),
      screenName: this.router.url,
    });
  }
}
